import script from "./ViewCommande.vue?vue&type=script&setup=true&lang=ts"
export * from "./ViewCommande.vue?vue&type=script&setup=true&lang=ts"

import "./ViewCommande.vue?vue&type=style&index=0&id=17cf3b4a&lang=scss"

const __exports__ = script;

export default __exports__